import Reveal from "@/components/Reveal";
import { ArrowRight } from "lucide-react";
import { useSignup } from "@/context/SignupContext";
import { SIGNUP_ENABLED, CTA_LABEL } from "@/lib/config";

const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/2a594c21-650d-45e7-b5a4-d643f77ca0a9/images/0f5a5f376c8d3923d827cf8a7426e8f246a4311d2742eed5e33d6428a65dd43e.jpeg";

export default function Hero() {
  const { openSignup } = useSignup();
  return (
    <section id="top" data-testid="hero-section" className="relative overflow-hidden grain bg-[#FFEDE0]">
      <div className="max-w-md mx-auto md:max-w-6xl px-5 md:px-8 pt-2 pb-12 md:pt-4 md:pb-20">
        <div className="md:grid md:grid-cols-2 md:gap-12 md:items-center">
          <div className="md:order-1">
            <Reveal delay={80}>
              <h1
                data-testid="hero-headline"
                className="font-display text-[38px] leading-[1.05] md:text-6xl lg:text-[64px] font-extrabold tracking-tight text-balance"
              >
                Fellow travellers.{" "}
                <span className="relative inline-block">
                  <span className="relative z-10">Curated tables.</span>
                  <span className="absolute inset-x-0 bottom-1 md:bottom-2 h-3 md:h-4 bg-[#FF5A36]/25 -z-0 rounded" />
                </span>{" "}
                Genuine connections.
              </h1>
            </Reveal>

            <Reveal delay={160}>
              <p
                data-testid="hero-subhead"
                className="mt-5 text-[17px] md:text-xl text-[#5C5C5C] leading-relaxed text-balance max-w-xl"
              >
                No profiles, no swiping, no massive crowds. Just intentional, small-group meetups of{" "}
                <span className="text-[#1A1A1A] font-semibold">4–6 travellers</span> showing up for good food,
                great vibes, and easy conversations.
              </p>
            </Reveal>

            <div id="join" className="mt-7 flex flex-col sm:flex-row sm:items-center gap-3">
              <Reveal delay={240}>
                <button
                  onClick={SIGNUP_ENABLED ? openSignup : undefined}
                  disabled={!SIGNUP_ENABLED}
                  data-testid="hero-signup-cta"
                  className="inline-flex items-center justify-center gap-2 h-13 px-6 py-3.5 rounded-2xl bg-[#FF5A36] hover:bg-[#E0411F] disabled:hover:bg-[#FF5A36] text-white font-semibold text-base shadow-[0_10px_30px_-12px_rgba(255,90,54,0.5)] transition active:scale-[0.98] disabled:cursor-default disabled:opacity-95"
                >
                  {CTA_LABEL}
                  <ArrowRight className="h-5 w-5" />
                </button>
              </Reveal>
              <Reveal delay={280}>
                <span className="text-xs text-[#5C5C5C] flex items-center gap-2">
                  <span className="inline-block h-1.5 w-1.5 rounded-full bg-[#FF5A36]" />
                  Takes 60 seconds.
                </span>
              </Reveal>
            </div>

            <Reveal delay={340}>
              <p
                data-testid="hero-locations"
                className="mt-5 text-[12px] text-[#5C5C5C] font-medium tracking-wide"
              >
                Launching first in <span className="text-[#1A1A1A] font-semibold">Canggu</span>. More locations coming soon.
              </p>
            </Reveal>
          </div>

          <Reveal delay={120} className="mt-10 md:mt-0 md:order-2">
            <div className="relative">
              <div className="absolute -top-4 -left-4 h-24 w-24 rounded-full bg-[#FFC857]/40 blur-2xl" />
              <div className="absolute -bottom-6 -right-6 h-32 w-32 rounded-full bg-[#FF5A36]/30 blur-3xl" />
              <div className="relative rounded-[28px] overflow-hidden ring-1 ring-black/5 shadow-[0_30px_60px_-20px_rgba(255,90,54,0.25)]">
                <img
                  src={HERO_IMG}
                  alt="Travellers enjoying food and drinks at a Bali beach club"
                  className="w-full aspect-[4/5] md:aspect-[5/6] object-cover"
                />
                <div className="absolute inset-x-3 bottom-3 md:inset-x-5 md:bottom-5">
                  <div className="rounded-2xl bg-white/90 backdrop-blur border border-white px-4 py-3 flex items-center gap-3 shadow-lg">
                    <span className="inline-flex h-2.5 w-2.5 rounded-full bg-[#FF5A36] animate-pulse" />
                    <div className="text-sm">
                      <div className="font-semibold text-[#1A1A1A]">Food &amp; drinks at the beach club</div>
                      <div className="text-[#5C5C5C]">5 travellers matched · Sat 3:00 pm</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
